import { create } from 'zustand'
import { getCloverNavStatus } from '@/services/cloverReports'
import { todayIsoDate } from '@/utils/waterfallCalculator'

interface CloverNavState {
  allocateIncompleteCount: number
  giftCardIncompleteCount: number
  lastFetchedChicagoDate: string | null
  fetchNavStatus: (opts?: { refresh?: boolean }) => Promise<void>
}

export const useCloverNavStore = create<CloverNavState>((set) => ({
  allocateIncompleteCount: 0,
  giftCardIncompleteCount: 0,
  lastFetchedChicagoDate: null,
  fetchNavStatus: async (opts) => {
    try {
      const status = await getCloverNavStatus(opts)
      set({
        allocateIncompleteCount: status.allocate_incomplete_count,
        giftCardIncompleteCount: status.gift_card_incomplete_count,
        lastFetchedChicagoDate: todayIsoDate(),
      })
    } catch (err) {
      console.error('Failed to fetch Clover nav status:', err)
    }
  },
}))
